import styled from 'styled-components';
import {Link} from 'react-router-dom';

export const ButtonColorWrapper = styled.div`
  background-color: ${props => props.headerColor};
  border-radius: ${props => props.theme.homePage.panelContent.button.radius};
  max-width: ${props => props.theme.homePage.panelContent.button.width};
  margin: ${props => props.theme.homePage.panelContent.button.margin};
`;

export const ButtonStyled = styled(Link)`
  text-transform: uppercase;
  display: block;
  color: ${props => props.theme.homePage.panelContent.button.color};
  font-size: ${props => props.theme.homePage.panelContent.button.fontSize};
  margin: ${props => props.theme.homePage.panelContent.button.margin};
  padding: ${props => props.theme.homePage.panelContent.button.padding};
  max-width: ${props => props.theme.homePage.panelContent.button.width};
  border-radius: ${props => props.theme.homePage.panelContent.button.radius};
  &:hover {
    background: ${props => props.theme.homePage.panelContent.button.hoverColor1};
  }
`;



// WEBPACK FOOTER //
// ./components/TradeShowButton/TradeShowButton.style.js